import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { useSelector } from 'react-redux';
import store, { addToFavourite, removeFromFavourite } from '../../store/store';
import LoginModal from '../LoginModal/LoginModal';
import './FavouriteButton.css';

const FavouriteButton = ({ productId }) => {
    const isAuthenticated = useSelector((state) => state.service.isAuthenticated);
    const favouriteIds = useSelector((state) => state.favourite.favouriteIds);
    const isFavourite = favouriteIds.includes(productId);
    const [isOpen, setIsOpen] = useState(false);

    const toggleFavourite = async () => {
        const data = { productId };
        const endpoint = isFavourite ? '/Favourite/Remove' : '/Favourite/Add';

        try {
            const resp = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (!resp.ok) {
                const respData = await resp.json();
                alert(respData.message);
                return;
            }

            if (isFavourite) {
                store.dispatch(removeFromFavourite(productId));
                return;
            }

            store.dispatch(addToFavourite(productId));
        } catch (err) {
            alert(isFavourite ? 'Ошибка удаления из избранного' : 'Ошибка добавления в избранное');
        }
    };

    const button = (
        <button
            onClick={isAuthenticated ? toggleFavourite : () => setIsOpen(true)}
            className={`favourite-button ${isFavourite ? 'is-active' : ''}`}
            type="button"
            aria-label={isFavourite ? 'Remove from favourites' : 'Add to favourites'}
        >
            <Heart size={18} className="favourite-button__icon" />
        </button>
    );

    if (isAuthenticated) {
        return button;
    }

    return (
        <>
            {button}
            <LoginModal isOpen={isOpen} setIsOpen={setIsOpen} />
        </>
    );
};

export default FavouriteButton;
